import { render, staticRenderFns } from "./instructionDialog.vue?vue&type=template&id=5e6c5e4d&scoped=true&"
import script from "./instructionDialog.vue?vue&type=script&lang=js&"
export * from "./instructionDialog.vue?vue&type=script&lang=js&"
import style0 from "./instructionDialog.vue?vue&type=style&index=0&id=5e6c5e4d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c5e4d",
  null
  
)

export default component.exports